<template>
  <article class="sh-messaging-empty-state">
    <div class="sh-messaging-empty-icon-circle">
      <i class="fal fa-message-medical" aria-hidden="true"></i>
    </div>
    <h3 class="sh-messaging-empty-title">Start a new message</h3>
    <div class="sh-messaging-empty-body">
      <p>
        Start a new direct message or group chat by choosing from one of
        your Rallies then select the members you&rsquo;d like to message.
      </p>
    </div>
  </article>
</template>

<script>
  export default {
  }
</script>
